import React, { useContext, useState } from 'react'
import { AuthContext } from '../../AuthProvider'
import { Avatar, Button, Grid, TextField } from '@mui/material'
import { auth,database } from '../../firebaseConfig'
import { updateProfile,EmailAuthProvider, reauthenticateWithCredential, updatePassword  } from 'firebase/auth'
import { updateDoc,doc } from 'firebase/firestore'

function Profile() {
    const { user } = useContext(AuthContext)
    const [nomComplet, setNomComplet] = useState(user.displayName)
    const [email, setEmail] = useState(user.email)
    const [changePassword, setChangePassword] = useState(false)
    const [editProfile, setEditProfile] = useState(false)
    const [currentPassword, setCurrentPassword] = useState('')
    const [newPassword, setNewPassword] = useState('')
    const [confirmPassword, setConfirmPassword] = useState('')
    const updateProfileUser = () => {
        updateProfile(auth.currentUser, {
            displayName: nomComplet
        }).then(() => {
            updateUserTable().then((result) => {
                setEditProfile(false)
                setChangePassword(false)
            })
        }).catch((error) => {

        });
    }
    const changePasswordUser=()=>{
        const credential = promptForCredentials()
        reauthenticateWithCredential(auth.currentUser, credential).then(() => {
            confirmChangePassword()
          }).catch((error) => {
             console.log('Erreur')
          });
    }
    const confirmChangePassword=()=>{
        updatePassword(auth.currentUser, newPassword).then(() => {
            setEditProfile(false)
            setChangePassword(false)
          }).catch((error) => {
            console.log('Erreur')
          });
    }
    const updateUserTable = async () => {
        const userDocRef = doc(database, 'utilisateur', user.user_id)
        try {
            await updateDoc(userDocRef, {
                user_uid: user.uid,
                nom: nomComplet,
                type: user.type,
                chu_id: user.chu_id
            })
        } catch (err) {
            alert(err)
        }
    }
    function promptForCredentials() {
        const credential = EmailAuthProvider.credential(email, currentPassword);
        return credential;
      }
    return (
        <div style={{ width: '100%', display: 'flex', justifyContent: 'center' }} >
            <Grid container spacing={2}>
                <Grid item xs={12} sm={4} style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                    <img src={require('../../assets/logo_officiel.png')} width={200} height={200} />
                </Grid>
                <Grid item xs={12} sm={8} style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                    <Grid container spacing={2}>
                        <Grid item xs={12}>
                            <TextField
                                fullWidth
                                id="outlined-multiline-static1"
                                label="Type"
                                defaultValue={user.type}
                                variant="filled"
                                size='small'
                                disabled
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <TextField
                                fullWidth
                                id="outlined-multiline-static2"
                                label={user.chu_nom == '' || user.chu_nom == null ? 'Entité' : 'Chu'}
                                defaultValue={user.chu_nom == '' || user.chu_nom == null ? 'CENTRALE' : user.chu_nom}
                                variant="filled"
                                size='small'
                                disabled
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <TextField
                                fullWidth
                                id="outlined-multiline-static4"
                                label="Nom d'utilisateur"
                                value={email}
                                variant="filled"
                                size='small'
                                disabled
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <TextField
                                fullWidth
                                id="outlined-multiline-static3"
                                label="Nom complet"
                                value={nomComplet}
                                variant="filled"
                                size='small'
                                disabled={!editProfile}
                                onChange={(e) => {
                                    setNomComplet(e.target.value)
                                }}
                            />
                        </Grid>
                        {changePassword && (
                            <>
                                <Grid item xs={12}>
                                    <TextField
                                        fullWidth
                                        id="outlined-multiline-static5"
                                        label="Ancien mot de passe"
                                        value={currentPassword}
                                        variant="filled"
                                        size='small'
                                        type='password'
                                        onChange={(e)=>{
                                            setCurrentPassword(e.target.value)
                                        }}
                                    />
                                </Grid>
                                <Grid item xs={12}>
                                    <TextField
                                        fullWidth
                                        id="outlined-multiline-static6"
                                        label="Nouvelle mot de passe"
                                        value={newPassword}
                                        variant="filled"
                                        size='small'
                                        type='password'
                                        onChange={(e)=>{
                                            setNewPassword(e.target.value)
                                        }}
                                    />
                                </Grid>
                                <Grid item xs={12}>
                                    <TextField
                                        fullWidth
                                        id="outlined-multiline-static7"
                                        label="Confimation mot de passe"
                                        type='password'
                                        value={confirmPassword}
                                        variant="filled"
                                        size='small'
                                        onChange={(e)=>{
                                            setConfirmPassword(e.target.value)
                                        }}
                                    />
                                </Grid>
                            </>
                        )}
                    </Grid>
                </Grid>
                {!changePassword && !editProfile && (
                    <Grid item xs={12}>
                        <div >
                            <Button onClick={() => {
                                setEditProfile(!editProfile)
                                setChangePassword(false)
                            }}
                                variant='contained'
                                sx={{ textTransform: "none" }}
                            >Modifier mon profil</Button>
                            <Button
                                onClick={() => {
                                    setChangePassword(!changePassword)
                                    setEditProfile(false)
                                }}
                                variant='contained'
                                sx={{ ml: {xs:0,sm:1},mt:{xs:1,sm:0}, textTransform: "none" }}
                            >Changer mot de passe</Button>
                        </div>
                    </Grid>
                )}
                {changePassword && (
                    <Grid item xs={12}>
                        <div style={{ alignItems: 'flex-end' }}>
                            <Button
                                onClick={() => {
                                    setEditProfile(false)
                                    setChangePassword(false)
                                }}
                                variant='contained'
                                color='error'
                                sx={{ textTransform: "none" }}
                            >Annuler</Button>
                            <Button onClick={changePasswordUser}
                                variant='contained'
                                color='success'
                                sx={{ ml: 1, textTransform: 'none' }}
                            >Confirmer</Button>
                        </div>
                    </Grid>
                )}
                {editProfile && (
                    <Grid item xs={12}>
                        <div style={{ alignItems: 'flex-end' }}>
                            <Button
                                onClick={() => {
                                    setEditProfile(false)
                                    setChangePassword(false)
                                }}
                                variant='contained'
                                color='error'
                                sx={{ textTransform: "none" }}
                            >Annuler</Button>
                            <Button onClick={updateProfileUser}
                                variant='contained'
                                color='success'
                                sx={{ ml: 1, textTransform: 'none' }}
                            >Confirmer</Button>
                        </div>
                    </Grid>
                )}

            </Grid>
        </div>
    )
}

export default Profile